import axios from 'axios';
import { handleSuccess, handleError } from './axiosHandler';
import { authHeader } from '../_helpers/auth-header';

import { config } from '../config';
const base_url = config.apiUrl;

export const attachmentsService = {
  upload,
  getById,
  delete: _delete,
  UploadSellerFormImage,
  ChangeOrder,
};

function upload(form) {
  const url = base_url + 'Attachments/upload';
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.post(url, form);
}

function getById(id) {
  const url = base_url + 'Attachments/' + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader() });
}

function _delete(id) {
  const url = base_url + 'Attachments/' + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.delete(url, { headers: authHeader() });
}

function UploadSellerFormImage(files) {
  const url = base_url + 'Attachments/UploadSellerFormImage/';
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.post(url, files);
}

function ChangeOrder(id, dto) {
  const url = base_url + 'Attachments/ChangeOrder/' + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.post(url, dto, { headers: authHeader() });
}
